import { getStorage, ref, getDownloadURL } from "firebase/storage";

const storage = getStorage();
const cache = new Map();

export async function resolveMaybeStorageUrl(val = "") {
    const v = String(val || "");
    if (!v) return "";

    // already usable url
    if (/^(https?:|data:|blob:)/i.test(v)) return v;

    // public folder path (contoh: /images/yasin.png)
    if (v.startsWith("/")) return v;

    // optional: kalau tersimpan "images/xxx.png" tapi sebenarnya public
    if (v.startsWith("images/")) return `/${v}`;

    if (cache.has(v)) return cache.get(v);

    try {
        const url = await getDownloadURL(ref(storage, v));
        cache.set(v, url);
        return url;
    } catch {
        // cache juga supaya tak spam retry 404
        cache.set(v, v);
        return v;
    }
}
